import React, { useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import PropTypes from 'prop-types';
import { formDataFromServerShape } from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
import { setErrorAlert } from 'AppSrc/core/actions/actions-error-alert';
import { ModalPortal } from 'AppSrc/core/components/portals/modal-portal';
import {
  VFRadioButtonBase,
} from 'AppSrc/core/components/forms/form-base-components/v-f-radio-button-base';
import {
  addSignature,
} from 'AppSrc/core/approvers/approvals-queries';
import {
  // updateEditCrqWithId,
  updateRemedyRefCrqWithId,
} from 'AppSrc/core/actions/actions-update-edit-form';
import {
  // clearEditSectionsRead,
  fetchRemedyRefCrqForError,
} from 'AppSrc/core/actions/actions-edit-form';
import { CRQ_TRANSITION_CONFIRMATION } from 'AppSrc/core/components/router/routes';
import {
  REJECTED_FROM_APPROVALS,
} from 'AppSrc/core/crq/crq-status-transitions';
import { FormSection } from 'AppSrc/core/components/forms/form-section';
import { defaultFieldLogic } from 'AppSrc/core/components/forms/form-base-components/data-structure/default-field-logic';
import { getDisplayOptionsForApprovers } from 'AppSrc/core/components/view-crq-screen/utility-functions/get-display-options-for-approvers';
import { Loader } from 'AppSrc/core/components/utility/loader';
import { REJECT_APPROVAL_STATUS } from 'AppSrc/core/approvers/approval-statuses';
import { approverRejectionReason } from './approver-rejection-reason';
import { approverListRadioSelector } from './approver-list-radio-selector';



const getCurrentFields = (params) => {
  const {
    // values = {},
    formData = {},
    // touched = {},
    // userRoles,
  } = params;

  const currentFields = [];

  currentFields.push({
    ...defaultFieldLogic,
    componentData: {
      ...approverListRadioSelector,
      displayOptions: getDisplayOptionsForApprovers(formData),
    },
  });

  currentFields.push({
    ...defaultFieldLogic,
    componentData: approverRejectionReason,
  });

  return currentFields;
};



const vFParams = {
  fieldTitle: '',
  displayType: 'big',
};

const ApprovalGroupSelector = ({
  value,
  setapproverGroupSelected,
  displayOptions,
  touched,
  setTouched,
}) => {
  const formattedDisplayOptions = displayOptions.map((displayOption) => ({
    text: displayOption.text,
    value: displayOption.value.id,
  }));

  const setValue = (newValue) => {
    if (touched !== true) {
      setTouched(true);
    }
    const formattedValueArr = displayOptions.filter((displayOption) => displayOption.value.id === newValue);
    const formattedValue = formattedValueArr[0] ? formattedValueArr[0].value : null;
    setapproverGroupSelected(formattedValue);
  };

  const formattedValue = value ? value.id : null;
  const displayNameForValue = value ? value.text : null;

  const displayText = displayNameForValue ? displayNameForValue : 'Reject on behalf of';


  const errors = {
    inlineErrors: [],
  };

  if (!formattedValue) {
    errors.inlineErrors.push('Please select an Approver group');
  }

  return (
    <VFRadioButtonBase
      displayOptions={formattedDisplayOptions}
      disabledFieldOptions={{}}
      vFParams={vFParams}
      name="approver-groups"
      value={formattedValue}
      errors={errors}
      touched={touched}
      setValue={setValue}
      displayText={displayText}
    />
  );
};


ApprovalGroupSelector.propTypes = {
  value: PropTypes.arrayOf(PropTypes.object),
  setapproverGroupSelected: PropTypes.func,
  displayOptions: PropTypes.arrayOf(PropTypes.object),
  touched: PropTypes.bool,
  setTouched: PropTypes.func,
};


const ApprovalRejectModalDisplay = ({
  closeModal,
  formData,
  network,
  crqId,
  errorAlert,
  remedyRefFormData,
}) => {

  const history = useHistory();
  const [isSubmitting, setSubmitting] = useState(false);
  const dispatch = useDispatch();

  const handleApprovalApprove = (values) => {

    const approverGroupSelected = values.dataByFieldId[approverListRadioSelector.id].value;
    const reason = values.dataByFieldId[approverRejectionReason.id].value;

    setSubmitting(true);
    const approvalSignture = {
      network,
      crq_id: crqId,
      signature: approverGroupSelected.signature,
      reason,
      status: REJECT_APPROVAL_STATUS,
    };
    addSignature(approvalSignture).then((success) => {
      setSubmitting(false);
      if (success === true) {
        // if related reject then mobile ticket reject(VINE)
        if ((remedyRefFormData.status === '5' || remedyRefFormData.status === 'Scheduled For Approval') && remedyRefFormData.approvers[0] !== 'rejected') {
          const refGroupSelected = remedyRefFormData.approvers[0];
          const newRefSignature = {
            network: remedyRefFormData.network,
            crq_id: remedyRefFormData.id,
            signature: refGroupSelected.signature,
            reason: 'Since related fixed got rejected mobile also rejected',
            status: REJECT_APPROVAL_STATUS,
          };
          addSignature(newRefSignature).then((response) => {
            setSubmitting(false);
            if (response === 200) {
              console.log('rel mobile reject');
            }
          }).catch((error) => {
            console.error(error);
            errorAlert({
              errorTitle: 'Failed to approve CRQ',
              errorText: 'Unable to approve CRQ. It may have been already approved or rejected by a peer. Please refresh the page and try again.',
            });
          });
        }
        // We don't want to reject the Impacted Mobile CRQ from scheduled stage if Fixed CRQ is rejected, instead we are moving Mobile CRQ to Coordinator Stage.
        else if (remedyRefFormData.status === '6' || remedyRefFormData.status === 'Scheduled') {
          const remedyRefStatus = 'Planning In Progress';
          const remedyRefStatusReason = null;
          dispatch(updateRemedyRefCrqWithId(crqId, remedyRefStatus, remedyRefStatusReason))
            .catch((error) => {
              console.error(error);
              fetchRemedyRefCrqForError(error);
              return Promise.reject(error);
            });
        }
        const successPath = CRQ_TRANSITION_CONFIRMATION.getPath({
          network,
          crqId,
          transitionId: REJECTED_FROM_APPROVALS,
        });
        history.push(successPath);
      }
    }).catch((error) => {
      console.error(error);
      errorAlert({
        errorTitle: 'Failed to approve CRQ',
        errorText: 'Unable to approve CRQ. It may have been already approved or rejected by a peer. Please refresh the page and try again.',
      });
    });
  };
  if (isSubmitting) {
    // set up a loader array that shows the loader at half loaded
    const loaderArray = [true, false];
    return (
      <Loader
        loaderArray={loaderArray}
        loaderTitle="Please wait whilst we reject the CRQ"
        loaderText="Do not close or refresh your browser whilst we do this."
      />
    );
  }
  return (
    <ModalPortal>
      <div
        className="v-f-modal-section submit-crq-modal"
      >
        <div className="v-f-modal-shadow" />
        <div className="v-f-modal-inner">
          <FormSection
            sectionTitle="On whose behalf are you rejecting this CRQ"
            sectionId="reject-crq-modal"
            getCurrentFields={getCurrentFields}
            formData={formData}
            modalOptions={{
              rejectCrq: true,
              back: closeModal,
            }}
            handleSuccessfulSubmit={handleApprovalApprove}
          />
        </div>
      </div>
    </ModalPortal>
  );
};

ApprovalRejectModalDisplay.propTypes = {
  formData: formDataFromServerShape,
  closeModal: PropTypes.func,
  network: PropTypes.string,
  crqId: PropTypes.string,
  errorAlert: PropTypes.func,
  remedyRefFormData: PropTypes.objectOf(PropTypes.string),
};



const mapStateToProps = (state, ownProps) => ({
  formData: state.editForm.formDataById[ownProps.crqId],
  remedyRefFormData: (state.remedyReferenceCrq === undefined && (Object.keys(state.remedyReferenceCrq).length === 0)) ? null : state.remedyReferenceCrq.crqData,
});


const mapDispatchToProps = (dispatch, ownProps) => ({
  errorAlert: (alertData) => {
    dispatch(setErrorAlert(alertData));
  },
});

const ApprovalRejectModal = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ApprovalRejectModalDisplay);






export { ApprovalRejectModal };
